import { render, staticRenderFns } from "./FightingTheDis.vue?vue&type=template&id=a96c9fdc&scoped=true&"
import script from "./FightingTheDis.vue?vue&type=script&lang=js&"
export * from "./FightingTheDis.vue?vue&type=script&lang=js&"
import style0 from "./FightingTheDis.vue?vue&type=style&index=0&id=a96c9fdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96c9fdc",
  null
  
)

export default component.exports